import { render } from "./StructuredNameField.vue?vue&type=template&id=11b9a41d"
import script from "./StructuredNameField.vue?vue&type=script&lang=ts"
export * from "./StructuredNameField.vue?vue&type=script&lang=ts"
script.render = render

export default script